export default __webpack_public_path__ + "static/media/emptyHomePlaceholder.4c65e9c3.png";